import contentStudioInstance from '@/utils/axiosContentStudio';

const assetUpdaters = {
  getSignedUrls: async (
    files: {
      file: File;
      metadata: {height: number; width: number; duration_millis: number};
    }[]
  ) => {
    const response = await contentStudioInstance.post(
      '/api/v1/assets/bulk-upload-urls',
      {
        files: files.map((file) => ({
          file_name: file.file.name,
          content_type: file.file.type,
          metadata: {
            height: file.metadata.height,
            width: file.metadata.width,
            duration_millis: file.metadata.duration_millis,
            size_bytes: file.file.size,
          },
        })),
      }
    );
    return response.data;
  },
  archiveAssets: async (assetIds: string[]) => {
    const response = await contentStudioInstance.post(
      '/api/v1/assets/batch-archive',
      {
        asset_ids: assetIds,
      }
    );
    return response.data;
  },
  moveAssetsToFolder: async (folderId: string, assetIds: string[]) => {
    const response = await contentStudioInstance.post(
      `/api/v1/assets/batch-move`,
      {
        folder_destination_id: folderId,
        asset_ids: assetIds,
      }
    );
    return response.data;
  },
  renameAsset: async (assetId: string, name: string) => {
    const response = await contentStudioInstance.patch(
      `/api/v1/assets/${assetId}/rename`,
      {new_name: name}
    );
    return response.data;
  },
};

export default assetUpdaters;
